const extractCity = (components: any) => {
  const locality = components.find(({ types }: any) => types.includes('locality'));
  if (locality) return locality.long_name;
  const postalTown = components.find(({ types }: any) => types.includes('postal_town'));
  if (postalTown) return postalTown.long_name;
  const neighborhood = components.find(({ types }: any) => types.includes('neighborhood'));
  if (neighborhood) return neighborhood.long_name;
  return null;
};

export default extractCity;
